module.exports = __webpack_public_path__ + "img/dengji3.f458a20b.png";